import React from 'react';
import { SEO } from '../components/seo/SEO';
import { useLanguage } from '../context/LanguageContext';
import { ProductLandingPage } from '../components/content/ProductLandingPage';

export const CleanCoreSurgeonPage: React.FC = () => {
  const { language } = useLanguage();

  const content = {
    de: {
      seo: {
        title: 'Strategische ERP-Modernisierung – SAP Clean Core',
        description: 'Clean-Core-Strategie als Fundament für S/4HANA, AI und Cloud.',
      },
      hero: {
        eyebrow: 'Strategische ERP-Modernisierung',
        title: 'Clean Core als Zukunftsfundament',
        subtitle:
          'Reduzieren Sie Legacy-Lasten und schaffen Sie eine belastbare S/4HANA-Roadmap.',
        cta: { label: 'ERP-Modernisierungs-Assessment', href: '/consultation' },
      },
      problem: {
        title: 'Strategischer Bedarf',
        items: [
          'Die 2027-Maintenance-Deadline ist ein Modernisierungshebel.',
          'Z-Code erhöht Komplexität, Kosten und Risiko.',
          'Transparenz über Nutzung und Abhängigkeiten fehlt.',
          'Betriebsrat und Datenschutz müssen von Anfang an berücksichtigt werden.',
        ],
      },
      solution: {
        title: 'Unser Ansatz',
        items: [
          {
            title: 'Usage Intelligence',
            desc: 'SCMON-Telemetrie identifiziert ungenutzten Code fundiert.',
          },
          {
            title: 'Works Council Safe',
            desc: 'Privacy Proxy anonymisiert Nutzerdaten vor der Analyse.',
          },
          {
            title: 'Modernization Roadmap',
            desc: 'Stilllegung, Refactoring und S/4HANA-Plan in einem Programm.',
          },
        ],
      },
      steps: {
        title: 'Engagement-Modell',
        items: [
          { title: 'Assess', desc: 'ABAP-Nutzung und Abhängigkeiten analysieren.' },
          { title: 'Freeze', desc: 'Nicht genutzte Transaktionen sichern und monitoren.' },
          { title: 'Modernize', desc: 'Clean-Core-Plan in die ERP-Roadmap integrieren.' },
        ],
      },
      cta: {
        title: 'Bereit für Ihre ERP-Modernisierung?',
        subtitle: 'Wir liefern eine belastbare Clean-Core-Strategie für 2027+.',
        button: { label: 'ERP-Modernisierungs-Assessment', href: '/consultation' },
      },
    },
    en: {
      seo: {
        title: 'Strategic ERP Modernization – SAP Clean Core',
        description: 'Clean-core strategy as the foundation for S/4HANA, AI, and cloud.',
      },
      hero: {
        eyebrow: 'Strategic ERP modernization',
        title: 'Clean core as a future foundation',
        subtitle:
          'Reduce legacy load and establish a defensible S/4HANA roadmap.',
        cta: { label: 'Request ERP modernization assessment', href: '/consultation' },
      },
      problem: {
        title: 'Strategic context',
        items: [
          'The 2027 maintenance deadline is a modernization catalyst.',
          'Z-code increases complexity, cost, and delivery risk.',
          'Visibility into usage and dependencies is limited.',
          'Works council and privacy constraints must be addressed early.',
        ],
      },
      solution: {
        title: 'Our approach',
        items: [
          {
            title: 'Usage intelligence',
            desc: 'SCMON telemetry identifies unused code with evidence.',
          },
          {
            title: 'Works Council Safe',
            desc: 'Privacy proxy anonymizes user data before analysis.',
          },
          {
            title: 'Modernization roadmap',
            desc: 'Decommissioning, refactoring, and S/4HANA planning in one program.',
          },
        ],
      },
      steps: {
        title: 'Engagement model',
        items: [
          { title: 'Assess', desc: 'Analyze ABAP usage and dependencies.' },
          { title: 'Freeze', desc: 'Secure unused transactions and monitor usage.' },
          { title: 'Modernize', desc: 'Integrate clean-core plan into the ERP roadmap.' },
        ],
      },
      cta: {
        title: 'Ready for ERP modernization?',
        subtitle: 'We deliver a defensible clean-core strategy for 2027+.',
        button: { label: 'Request ERP modernization assessment', href: '/consultation' },
      },
    },
  }[language];

  return (
    <>
      <SEO title={content.seo.title} description={content.seo.description} />
      <ProductLandingPage content={content} />
    </>
  );
};

export default CleanCoreSurgeonPage;
